import { Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

// منتقي أهداف الإداري المشترك بين بوابة الموظف وواجهة المدير
export default function AdminGoalPicker({ catalog, picked, setPicked, onSave, onCancel, saving, testIdPrefix = "goal" }) {
  const toggle = (id) => setPicked(
    picked.includes(id) ? picked.filter((x) => x !== id)
      : picked.length < catalog.max_goals ? [...picked, id] : picked);
  const valid = picked.length >= catalog.min_goals && picked.length <= catalog.max_goals;
  return (
    <div className="space-y-3" data-testid={`${testIdPrefix}-picker`}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-bold text-slate-500">
          اختر من {catalog.min_goals} إلى {catalog.max_goals} أهداف
        </p>
        <span className={`text-xs font-extrabold rounded-full border px-3 py-1 ${valid ? "text-emerald-800 bg-emerald-50 border-emerald-200" : "text-amber-800 bg-amber-50 border-amber-200"}`}
          data-testid={`${testIdPrefix}-count`}>
          اخترت {picked.length} / {catalog.max_goals}
        </span>
      </div>
      {catalog.axes.map((a) => (
        <div key={a.axis} className="rounded-xl border p-3 space-y-1.5">
          <p className="text-xs font-extrabold text-emerald-900">{a.axis}</p>
          {a.goals.map((g) => {
            const on = picked.includes(g.id);
            return (
              <label key={g.id} className={`flex items-start gap-2.5 cursor-pointer rounded-lg border p-2.5 transition-colors ${on ? "border-emerald-600 bg-emerald-50/60" : "border-transparent hover:bg-slate-50"}`}
                data-testid={`${testIdPrefix}-opt-${g.id}`}>
                <input type="checkbox" checked={on} onChange={() => toggle(g.id)}
                  className="mt-0.5 w-4 h-4 accent-emerald-800 shrink-0" />
                <span>
                  <span className="block text-xs font-bold">{g.title}</span>
                  <span className="block text-[11px] text-slate-400 leading-5">{g.desc}</span>
                </span>
                {on && <Check className="w-4 h-4 text-emerald-700 mr-auto shrink-0 mt-0.5" />}
              </label>
            );
          })}
        </div>
      ))}
      <div className="flex gap-2">
        <Button onClick={onSave} disabled={saving || !valid} data-testid={`${testIdPrefix}-save`}
          className="h-10 text-xs font-bold gap-1.5 bg-emerald-900 hover:bg-emerald-950 text-white">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
          حفظ الأهداف ({picked.length})
        </Button>
        {onCancel && (
          <Button variant="outline" onClick={onCancel} data-testid={`${testIdPrefix}-cancel`}
            className="h-10 text-xs">إلغاء</Button>
        )}
      </div>
    </div>
  );
}
